import { render, staticRenderFns } from "./endIndex.vue?vue&type=template&id=544bfc63&scoped=true&"
import script from "./endIndex.vue?vue&type=script&lang=js&"
export * from "./endIndex.vue?vue&type=script&lang=js&"
import style0 from "./endIndex.vue?vue&type=style&index=0&id=544bfc63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544bfc63",
  null
  
)

export default component.exports